import CodeField from './CodeField'

const HtmlField = props => {
  return (
    <CodeField language="html" {...props}/>
  )
}

export default HtmlField